import React from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import AboutDoctor from "./AboutDoctor";
import AppointmentCTA from "./AppointmentCTA";
import ContactCard from "./ContactCard";
import MapEmbed from "./MapEmbed";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import SEO from "./SEO";

export default function LandingPage() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "Aarogyam Homoeopathic Clinic",
    "description": "Expert homoeopathic treatment for all diseases. Natural, safe, and effective medicine with personalized care.",
    "url": "https://aarogyamclinic.com",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Your Street Address",
      "addressLocality": "Your City", 
      "addressRegion": "Your State",
      "postalCode": "XXXXXX",
      "addressCountry": "IN"
    },
    "openingHours": "Mo-Sa 09:00-18:00",
    "medicalSpecialty": "Homoeopathy"
  };

  return (
    <>
      <SEO 
        title="Aarogyam Homoeopathic Clinic - Best Homoeopathic Doctor in India | Natural Treatment"
        description="Expert homoeopathic treatment for all diseases. Natural, safe, and effective medicine with personalized care. Book appointment online with experienced homoeopathic doctor."
        keywords="homoeopathic doctor, homoeopathic clinic, natural treatment, homoeopathy, best homoeopathic doctor, homoeopathic medicine, alternative medicine, holistic treatment, India"
        schema={schema}
      />
      <div className="min-h-screen bg-gray-50">
        <Header />
        <HeroSection />
        <AboutDoctor />
        <AppointmentCTA />
        <ContactCard />
        <MapEmbed />
        <Footer />
        <WhatsAppButton />
      </div>
    </>
  );
}
